module.exports = __webpack_public_path__ + "static/media/happy-icon.690c3fc7.svg";